<div [editableInStoryblok]="_editable" [ngClass]="maxWidth" class="mx-auto">
	<h2 [ngClass]="headingSize()">{{ title }}</h2>
</div>
